// extracted by mini-css-extract-plugin
export const fullWidth = "InsightButton__fullWidth__K0rIR";
export const insightButton = "InsightButton__insightButton__HglxZ";